const offset = 100 * (141 / 255);

const textColourFromNodes = elementNodes => {
  return Array.from(elementNodes).reduce((colours, textNode) => {
    colours.push(textNode.style.color);
    return colours;
  }, []);
}

const lightnessFromRGB = rgb => {
  let [r, g, b] = rgb.substring(4, rgb.length-1)
         .replace(/ /g, '')
         .split(',');

  // Then get lightness from HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r,g,b),
      cmax = Math.max(r,g,b),
      lightness = 0;

  lightness = (cmax + cmin) / 2;
  lightness = +(lightness * 100).toFixed(1);

  return lightness;
}

const lightnessFromColourArray = colourArray => {
  return colourArray.map(colour => lightnessFromRGB(colour));
}

const filterDuplicates = array => [...new Set(array)];

const average = array => array.reduce((total, value) => total + value, 0) / array.length;

export const averageLightness = (colourNodes, useOffset = false) => {
  const colourArray = textColourFromNodes(colourNodes);
  const filteredArray = filterDuplicates(colourArray);
  const lightnessArray = lightnessFromColourArray(filteredArray);
  const averageLightness = average(lightnessArray);

  return useOffset ? averageLightness + offset : averageLightness;
}

// Returns #HEX from Hue Saturation Lightness
export const hslToHex = (hue, saturation, lightness) => {
  if (
    (typeof hue !== 'number' || hue < 0 || hue > 360) ^
    (typeof saturation !== 'number' || saturation < 0 || saturation > 100) ^
    (typeof lightness !== 'number' || lightness < 0 || lightness > 100)
  ) {
    console.warn(
      'Supplied HSL values are not numbers or out of range, Hue (0-360):',
      hue,
      ' Saturation (0-100): ',
      saturation,
      ' Lightness (0-100): ',
      lightness,
      ' returning white.',
    );
    return '#FFFFFF';
  }

  const hDecimal = lightness / 100;
  const a = (saturation * Math.min(hDecimal, 1 - hDecimal)) / 100;
  const f = (n) => {
    const k = (n + hue / 30) % 12;
    const color = hDecimal - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);

    // Convert to Hex and prefix with "0" if required
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};
